var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCarAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg_icon",
    viewBox: "0 0 26 19.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#243A53;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 6.2,
    y: 11.5,
    width: 1.9,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.5,7.8a5.8,5.8,0,0,0,.3-1.9A5.9,5.9,0,0,0,17.9,0a5.6,5.6,0,0,0-3.8,1.4H5.4L2.6,7.8H0v2H2.2v9.4h2V17.3H21.8v1.9h2V9.8H26v-2ZM17.2,2.5h1.4V3.9H17.2Zm0,2.6h1.4V9.4H17.2ZM6.7,3.4h5.8A6.6,6.6,0,0,0,12,5.9a5.8,5.8,0,0,0,.3,1.9H4.8ZM21.8,15.3H4.2V9.8h9.2a5.9,5.9,0,0,0,4.5,2.1v1.6h1.9v-2a5.6,5.6,0,0,0,2-1.1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarAlert);
export default __webpack_public_path__ + "static/media/icon-car-alert.fd0776c18603bcc3e15975ed6dcc528a.svg";
export { ForwardRef as ReactComponent };